import { render, staticRenderFns } from "./WxSimpleCalendarDatePicker.vue?vue&type=template&id=be2c2b70&scoped=true"
import script from "./WxSimpleCalendarDatePicker.vue?vue&type=script&lang=js"
export * from "./WxSimpleCalendarDatePicker.vue?vue&type=script&lang=js"
import style0 from "./WxSimpleCalendarDatePicker.vue?vue&type=style&index=0&id=be2c2b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2c2b70",
  null
  
)

export default component.exports